import { Injectable } from '@angular/core';
import { AnalyticsDataService, AppNotificationUtilClass } from '@monorepo/services';
import { TAnalyticsSearchRequestBase, TAnalyticsSearchResponseBase, TAnalyticsType } from '@monorepo/types';
import { catchError, finalize, lastValueFrom, Observable, of } from 'rxjs';

@Injectable()
export class AnalyticsFacade {
  constructor(
    private appNotificationUtilClass: AppNotificationUtilClass,
    private analyticsDataService: AnalyticsDataService,
  ) {}

  fetchAnalyticsConfig(analyticsType: TAnalyticsType) {
    switch (analyticsType) {
      case 'PLANI8_IN_HOUSE':
        return this.#fetchWithLoader(this.analyticsDataService.fetchPlani8InHouseConfig());
    }
  }

  /**
   * Component data is fetched without the global loader, every component shows its own loading state.
   * Errors are propagated so the component can show its try-again state.
   */
  searchAnalytics<TRequest extends TAnalyticsSearchRequestBase, TResponse extends TAnalyticsSearchResponseBase>(
    payload: TRequest,
  ) {
    return lastValueFrom(this.analyticsDataService.analyticsSearch<TRequest, TResponse>(payload));
  }

  async #fetchWithLoader<T>(call$: Observable<T>): Promise<T | null> {
    const loaderEl = await this.appNotificationUtilClass.presentLoading();
    const dismiss = () => this.appNotificationUtilClass.dismissLoadingV2(loaderEl);
    return lastValueFrom(
      call$.pipe(
        catchError(() => of(null)),
        finalize(dismiss),
      ),
    );
  }
}
